import { render, staticRenderFns } from "./PromotionAddUpdate.vue?vue&type=template&id=51f0ed08&"
import script from "./PromotionAddUpdate.vue?vue&type=script&lang=js&"
export * from "./PromotionAddUpdate.vue?vue&type=script&lang=js&"
import style0 from "./PromotionAddUpdate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports